module.exports = __webpack_public_path__ + "static/media/EdSider_Quick Guide (Parent)_062024_V2 1.c8065c63.pdf";